import YearlyAgreement36Form from './YearlyAgreement36Form'

export default YearlyAgreement36Form;